import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Filter from 'common/components/responsive/filter'
// import cx from 'classnames'
import Search from 'common/components/elements/inputs/search';
import Button from 'common/components/elements/buttons/primary';
import MobileFilter from 'common/components/modules/mobile-filter';


const statusFilter = [
   { value: 'active', name: 'Published', icon: 'store' },
   { value: 'scheduled', name: 'Scheduled', icon: 'clock' },
   { value: 'inactive', name: 'Unpublished', icon: 'unpublish' },
   // { value: 'active', name: 'Available', icon: 'store' },
   // { value: 'unavailable', name: 'Unavailable', icon: 'sold-out' },
   // { value: 'scheduled', name: 'Scheduled', icon: 'clock' },
   // { value: 'inactive', name: 'Hidden', icon: 'unpublish' },
];
const sortByFilter = [
   { name: 'Newest ', value: 'date_added:desc' },
   { name: 'Oldest', value: 'date_added:asc' },
   { name: 'Name • A - Z', value: 'name:asc' },
   { name: 'Name • Z - A', value: 'name:desc' },
   { name: 'Price • Low to high', value: 'price:asc' },
   { name: 'Price • High to low', value: 'price:desc' },

];
const typesFilter = [
   { name: 'Bundle', value: 'content_bundle_item' },
   { name: 'Digital item', value: 'digital_item' },
   { name: 'Downloadable digital item', value: 'attachment_item' },
   { name: 'Digital item pricing by the minute', value: 'priced_by_the_minute' },
   { name: 'Physical item', value: 'physical_item' },
   // { name: 'All', value: 'all' },
];

function StoreFilters({
   screenWidth,
   onFilterChange,
   activFilters,
   emptyFilters,
   categories,
   isReorderMode,
   onClearAllFilters,
   isEmpty,
   searchValue,
}) {

   const [filters, setFilters] = useState({
      status: { name: '', value: [] },
      categories: { name: '', value: [] },
      type: { name: '', value: [] },
      sortBy: { name: 'Newest', value: 'date_added:desc' },
      search: '',
   })

   const valueOfNumber = (arr) => {
      let i, n = arr.length;
      for(i = 0; i < n; ++i) {
         arr[i] = +arr[i];
      }
      return
   }

   const getDefaultFilters = () => {
      let status = { name: '', value: [] }
      let categories = { name: '', value: [] }
      let type = { name: '', value: [] }
      let search = ''
      let sortBy = {
         name: '',
         value: 'date_added:desc',
      }

      if(activFilters.status){
         status = { name: `${ activFilters.status.length } Selected`, value: activFilters.status }
      }
      if(activFilters.categories){
         valueOfNumber(activFilters.categories)
         categories = { name: `${ activFilters.categories.length } Selected`, value: activFilters.categories }
      }
      if(activFilters.type){
         type = { name: `${ activFilters.type.length } Selected`, value: activFilters.type }
      }
      if(activFilters.sortBy){
         sortBy = sortByFilter.find(i => i.value === activFilters.sortBy)
      }
      if(!!activFilters.search){
         search = activFilters.search
      }
      return { status, categories, sortBy, type, search }
   }

   useEffect(() => {
      if(!isReorderMode) {
         setFilters(getDefaultFilters())
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const onMultiplFilter = (value, name, type) => {
      let selectedFilterArray = []

      if(filters?.[type]?.value?.length) {
         if(filters?.[type]?.value?.includes(value)) {
            selectedFilterArray = filters?.[type].value.filter(el => el !== value)
         } else {
            selectedFilterArray = [...filters?.[type]?.value, value]
         }
      } else {
         selectedFilterArray = [...filters?.[type]?.value, value]
      }
      setFilters({
         ...filters,
         [type]: { name: selectedFilterArray.length ? `${ selectedFilterArray.length } Selected` : '', value: selectedFilterArray },
      })
      onFilterChange(selectedFilterArray, type)
   }

   const onSimpleFilter = (name, value, type) => {
      setFilters({
         ...filters,
         [type]: type === 'search' ? value : { name, value },
      })
      onFilterChange(value, type)
   }

   const onClickClear = (type, value) => {
      setFilters({
         ...filters,
         [type]: { name: '', value: value || '' },
      })
      onFilterChange('', type)
   }

   const onClickClearAll =  () => {
      setFilters({
         status: { name: '', value: [] },
         categories: { name: '', value: [] },
         type: { name: '', value: [] },
         sortBy: { name: '', value: 'date_added:desc' },
      })
      onClearAllFilters()
   }

   const calculateFiltersCount = () => {
      let count = 0

      Object.keys(filters).forEach(key => {
         if(typeof filters[key].value === 'string') {
            if(key === 'sortBy' && filters[key].value === 'date_added:desc') {
               return;
            } else {
               count += 1
            }
         } else if(Array.isArray(filters[key].value)) {
            count += filters[key].value.length
         }
      })

      return count;
   }

   return (
      <div>
         <div
            className={ `flex flex-row justify-between gap-2 ${ screenWidth <= 1024 ? 'flex-col ' : '' }` }
         >
            {
               screenWidth > 1024 && (
                  <div className={ `flex flex-row items-center flex-wrap gap-2 ${ screenWidth < 870 && 'overflow-x-auto' }` }>
                     <Filter
                        data={ typesFilter }
                        isMultiplSelect={ true }
                        type='filter'
                        onFilterChange={ (value, name) => {
                           onMultiplFilter(value, name, 'type')
                        } }
                        onClickClear={ () => {
                           onClickClear('type')
                        } }
                        hasClearButton={ true }
                        hasFilterButtonContent={ true }
                        isAutoSave
                        height='10'
                        desktopType={ screenWidth < 870 ? 'mobile' : 'descktop' }
                        activeSelectedValue={ filters.type }
                        name='Type'
                        showNewStyles={ true }
                        bgColor='bg-major-dark'
                        contentStyles={ {
                           left: '0px',
                           top: '44px',
                        } }
                        className={ ` bg-major-dark ` }
                        filterClassName='!flex-none'
                        filterValueKey='value'
                        disabled={ isReorderMode }
                     />
                     <Filter
                        isMultiplSelect
                        data={ statusFilter }
                        type='sort'
                        onFilterChange={ (value, name) => {
                           onMultiplFilter(value, name, 'status')
                        } }
                        onClickClear={ () => {
                           onClickClear('status')
                        } }
                        hasClearButton={ true }
                        hasFilterButtonContent={ false }
                        isAutoSave={ true }
                        height='10'
                        className={ ` !bg-major-dark hover:!bg-hover` }
                        desktopType={ screenWidth < 870 ? 'mobile' : 'descktop' }
                        activeSelectedValue={ filters.status }
                        version='v2'
                        name='Status'
                        showNewStyles={ true }
                        contentStyles={ {
                           left: '0px',
                           top: '44px',
                           width: '343px',
                        } }
                        filterClassName='!flex-none '
                        showNewRadioStyles
                        radioClassName='h-10 '
                        disabled={ isReorderMode }
                        contentMarginToLeftIcon='3'
                     />
                     <Filter
                        data={ categories }
                        isMultiplSelect={ true }
                        type='filter'
                        onFilterChange={ (value, name) => {
                           onMultiplFilter(value, name, 'categories')
                        } }
                        onClickClear={ () => {
                           onClickClear('categories')
                        } }
                        hasClearButton={ true }
                        hasFilterButtonContent={ true }
                        isAutoSave
                        height='10'
                        desktopType={ screenWidth < 870 ? 'mobile' : 'descktop' }
                        activeSelectedValue={ filters.categories }
                        name='Category'
                        showNewStyles={ true }
                        bgColor='bg-major-dark'
                        contentStyles={ {
                           left: '0px',
                           top: '44px',
                        } }
                        filterClassName='!flex-none'
                        filterValueKey='value'
                        contentClassName='ams-custom-scrool max-h-[300px] overflowY-auto'
                        disabled={ isReorderMode }
                     />
                     {
                        !emptyFilters && (
                           <div className='h-10 mx-2 whitespace-nowrap inline-block'>
                              <Button
                                 text='Clear all'
                                 textColor='secondary'
                                 backgroundColor='transparent'
                                 textSize='base'
                                 onClick={ onClickClearAll }
                                 classNames='h-full px-2 flex items-center'
                                 padding='none'
                                 iconName='cancel'
                                 fontIconColor='secondary'
                                 fontIconSize='large'
                                 iconPosition='left'
                              />
                           </div>
                        )
                     }
                  </div>
               )
            }
            <div className={ `flex ${ screenWidth <= 1024 ? 'flex-col gap-4 !w-full' : '' }` }>
               {
                  !isEmpty && screenWidth > 1024 && (
                     <div className={ `flex ${ screenWidth < 1148 ? '!w-fit' : '' }` }>
                        <Filter
                           name='Sorting'
                           type='sort'
                           data={ sortByFilter }
                           desktopType={ screenWidth < 870 ? 'mobile' : 'descktop' }
                           onFilterChange={ (value, name) => onSimpleFilter(name, value, 'sortBy') }
                           onClickShowResult={ () => {} }
                           activeSelectedValue={
                              {
                                 name: filters?.sortBy?.value === sortByFilter[0].value ? '' : filters?.sortBy?.name,
                                 value: filters?.sortBy?.value,
                              }
                           }
                           onClickClear={ () => {
                              onClickClear('sortBy')
                           } }
                           className=' mr-3 !bg-major-dark hover:!bg-hover'
                           version='v2'
                           bgColor='bg-major-dark'
                           activValueClassName='text-sm font-normal'
                           showNewStyles={ true }
                           height='10'
                           radioClassName='py-[10px] h-10'
                           contentStyles={ {
                              right: '11px',
                              top: '44px',
                           } }
                           showNewRadioStyles
                           disabledState={ isReorderMode ? ['name:asc', 'name:desc', 'price:asc', 'price:desc'] : [] }
                           hasClearButton={ false }
                           hasFilterButtonContent={ false }
                           isAutoSave
                           labelTooltipText='This view cannot be reordered'
                        />
                     </div>
                  )
               }
               <div className={ ` h-10 ${ screenWidth <= 1024 ? '!w-full flex gap-3' : 'min-w-[320px] max-w-[320px]' }` }>
                  <Search
                     onChange={ (e) => {
                        onSimpleFilter('search', e, 'search');
                     } }
                     value={ searchValue }
                     placeholder='Search store item'
                     version='2'
                     disabled={ isReorderMode }
                  />
                  {
                     screenWidth <= 1024 && (
                        <MobileFilter
                           sortOptions={ sortByFilter }
                           selectedSortValue={ filters?.sortBy?.value || '' }
                           sortName='sortBy'
                           disabledSortOptions={ isReorderMode ? ['name:asc', 'name:desc', 'price:asc', 'price:desc'] : [] }
                           disabledSortOptionTooltipText='This view cannot be reordered'
                           onFilterChange={ (value, name, filterName, isMultiple) => {
                              if(!isMultiple) {
                                 onSimpleFilter(name, value, filterName)
                              } else {
                                 onMultiplFilter(value, name, filterName)
                              }
                           } }
                           showClearAllFilters={ !emptyFilters }
                           onClickClearAllFilters={ onClickClearAll }
                           filtersCount={ calculateFiltersCount() }
                           filtersList={ [
                              {
                                 title: 'Type',
                                 isMultiple: true,
                                 filterName: 'type',
                                 optionNameKey: 'name',
                                 optionValueKey: 'value',
                                 options: typesFilter,
                                 selectedFilter: filters.type,
                                 disabled: isReorderMode,
                              },
                              {
                                 title: 'Status',
                                 isMultiple: true,
                                 filterName: 'status',
                                 optionNameKey: 'name',
                                 optionValueKey: 'value',
                                 options: statusFilter,
                                 selectedFilter: filters.status,
                                 disabled: isReorderMode,
                              },
                              {
                                 title: 'Category',
                                 isMultiple: true,
                                 filterName: 'categories',
                                 optionNameKey: 'name',
                                 optionValueKey: 'value',
                                 options: categories,
                                 selectedFilter: filters.categories,
                                 disabled: isReorderMode,
                              },
                           ] }
                        />
                     )
                  }
               </div>
            </div>
         </div>
      </div>
   )
}

StoreFilters.propTypes = {
   screenWidth: PropTypes.number,
   onFilterChange: PropTypes.func,
   activFilters: PropTypes.object,
   emptyFilters: PropTypes.bool,
   categories: PropTypes.array,
   isReorderMode: PropTypes.bool,
   onClearAllFilters: PropTypes.func,
   isEmpty: PropTypes.bool,
   searchValue: PropTypes.string,
}

export default StoreFilters
